var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '../../common/modal/abstract-modal-content.component';
import { ModalService } from '../../common/modal/modal.indra.service';
import scrollLock from 'scroll-lock';
import { INDRAApiService } from '@ibe/services';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as PromoVoucherActions from '@ibe/store/actions/promo-vouchers.actions';
import * as DeepLinkPriceMismatchActions from '@ibe/store/actions/deeplink-price-mismatch.actions';
import * as FlightInformationActions from '@ibe/store/actions/flight-information.indra.actions';
import * as OutboundFlightInformationActions from '@ibe/store/actions/outbound-flight-information.indra.actions';
import * as InboundFlightInformationActions from '@ibe/store/actions/inbound-flight-information.indra.actions';
import { takeWhile } from 'rxjs/operators';
var INDRANavigateAwayModalComponent = /** @class */ (function (_super) {
    __extends(INDRANavigateAwayModalComponent, _super);
    function INDRANavigateAwayModalComponent(modalService, router, store, apiService, storage) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.router = router;
        _this.store = store;
        _this.apiService = apiService;
        _this.storage = storage;
        _this.htmlElement = document.getElementsByTagName('html');
        _this.current_page$ = _this.store.select(fromStore.getSelectedBookingCurrentPage);
        _this.isLoading = false;
        _this.TYPE = 'dialog';
        _this.current_page$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.current_page = value;
        });
        return _this;
    }
    INDRANavigateAwayModalComponent.prototype.ngOnInit = function () {
    };
    INDRANavigateAwayModalComponent.prototype.closeModal = function () {
        this.modalService.close();
        if (this.htmlElement[0].classList.contains('no-scroll')) {
            if (this.router.url.indexOf('sidebar') < 0) {
                this.htmlElement[0].classList.remove('no-scroll');
                scrollLock.show();
            }
        }
    };
    INDRANavigateAwayModalComponent.prototype.TAP_handleCancel = function () {
        if (this.current_page === 'flights') {
            this.store.dispatch(new FlightInformationActions.ResetAction);
            this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
            this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
        }
        this.closeModal();
        this.modalService.navigateAwaySelection$.next(false);
    };
    INDRANavigateAwayModalComponent.prototype.TAP_handleConfirm = function () {
        var _this = this;
        this.store.dispatch(new DeepLinkPriceMismatchActions.ResetAction());
        // do not call signOut API if pnr is already created, otherwise signOut will return an error
        if (!this.storage.get('bookingPnr')) {
            this.isLoading = true;
            this.apiService.INDRA_signOutFromSession().subscribe(function (res) {
                _this.isLoading = false;
                // clear promocodes and vouchers in the store
                _this.store.dispatch(new PromoVoucherActions.ResetAction());
                _this.closeModal();
                _this.modalService.navigateAwaySelection$.next(true);
            }, function (error) { });
        }
        else {
            this.storage.remove('bookingPnr');
            // clear promocodes and vouchers in the store
            this.store.dispatch(new PromoVoucherActions.ResetAction());
            this.closeModal();
            this.modalService.navigateAwaySelection$.next(true);
        }
    };
    return INDRANavigateAwayModalComponent;
}(AbstractModalContentComponent));
export { INDRANavigateAwayModalComponent };
